<template>
  <v-file-input
    :disabled="loading || disabled"
    v-bind="$attrs"
    @update:modelValue="upload($event)"
    @click:clear="clear()"
  />
</template>

<script lang="ts" setup>
import { defineEmits, ref } from "vue";
import { DBFile } from "@/classes";

defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits<{
  (e: "upload", file: DBFile | null): void;
}>();

const loading = ref(false);
const upload = async (fileObject: File | File[]) => {
  loading.value = true;
  if (Array.isArray(fileObject)) {
    const file: DBFile = await DBFile.uploadFile(fileObject[0]);
    emit("upload", file);
  } else {
    const file: DBFile = await DBFile.uploadFile(fileObject);
    emit("upload", file);
  }
  loading.value = false;
};
const clear = () => {
  emit("upload", null);
};
</script>
